import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'mp-help-center-direct-link-button',
  templateUrl: './help-center-direct-link-button.component.html',
  styleUrl: './help-center-direct-link-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatAnchor, MatIcon, MatTooltip],
})
export class HelpCenterDirectLinkButtonComponent {
  readonly helpCenterLink: InputSignal<string> = input.required<string>();

  readonly isSmall: InputSignal<boolean> = input.required<boolean>();
}
